<!--  -->
<template>
  <div class="tankContainer">
    <div class="description">
      <div style="font-size: 18px; font-weight: bold">
        {{ tankData.material }}
      </div>
      <div style="font-size: 16px">
        <p>今日库存 {{ tankData.new }}</p>
        <p>昨日库存 {{ tankData.old }}</p>
        <p>变动值 {{ tankData.change }}</p>
      </div>
      <div class="tankName" @click="handleToDetail(tankData.name)">{{ tankData.name }}</div>
    </div>
    <canvas :id="canvasID" width="100" height="220"> </canvas>
    <div class="arrow">
      <span
        :class="`iconfont ${
          isIncrement ? 'icon-down-jiantou' : isDecrement ? 'icon-up' : ''
        }`"
        style="font-size: 40px"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tankData: {
      Type: Object,
      required: true,
      default: {}
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {
    canvasID () {
      return `tankCanvas-${this.tankData.name}`
    },
    isIncrement () {
      return this.tankData.new > this.tankData.old
    },
    isDecrement () {
      return this.tankData.new < this.tankData.old
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    resizeCanvas () {
      const canvas = document.getElementById(this.canvasID)
      // 画布宽度设置
      canvas.width = canvas.getBoundingClientRect().width
      // 固定画布高度
      canvas.height = 220
      // 重绘canvas内容
      this.draw(canvas.getContext('2d'), canvas.width, canvas.height)
    },
    // 100 220
    draw (ctx, width, height) {
      // 设置椭圆的中心点、宽高和旋转角度
      const centerX = width / 2
      const centerY = height / 2 + 80
      const radiusX = width / 2 // 水平半径
      const radiusY = 20 // 垂直半径
      const rotation = 0 // 旋转角度

      ctx.beginPath()
      ctx.ellipse(
        centerX,
        height / 2 -
          ((this.tankData.new * 200) / this.tankData.total - 100) * 0.8,
        radiusX,
        radiusY,
        rotation,
        0,
        2 * Math.PI
      )
      ctx.ellipse(centerX, centerY, radiusX, radiusY, rotation, 0, Math.PI)

      ctx.lineTo(
        0,
        height / 2 -
          ((this.tankData.new * 200) / this.tankData.total - 100) * 0.8
      )
      ctx.strokeStyle = 'white'
      ctx.fillStyle = 'green'
      ctx.fill()
      ctx.stroke()
      // 绘制主罐体
      ctx.beginPath()
      // 圆柱底
      ctx.ellipse(
        centerX,
        height / 2 - 80,
        radiusX,
        radiusY,
        rotation,
        0,
        2 * Math.PI
      )
      // 圆柱顶
      ctx.ellipse(centerX, centerY, radiusX, radiusY, rotation, 0, Math.PI)
      ctx.lineTo(0, 30)
      ctx.strokeStyle = 'white'
      ctx.stroke()

      // 绘制原液位
      ctx.beginPath()
      ctx.setLineDash([5])
      ctx.ellipse(
        centerX,
        height / 2 -
          ((this.tankData.old * 200) / this.tankData.total - 100) * 0.8,
        radiusX,
        radiusY,
        rotation,
        0,
        2 * Math.PI
      )
      ctx.strokeStyle = 'white'
      ctx.stroke()
    },
    handleToDetail (tankName) {
      this.$router.push({ path: '/lfd/warehouseManager/inventoryCollect', query: { tankName } })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.resizeCanvas()
    window.addEventListener('resize', () => {
      this.resizeCanvas()
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.resizeCanvas()
    })
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.tankContainer {
  display: flex;
  .description {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color:#fff;
    .tankName {
      color:#000;
      width: 80%;
      word-break: break-word;
      background-color: yellow;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
    }
  }
  canvas {
    width: 40%;
    display: block;
  }
  .arrow {
    width: 20%;
    min-width: 40px;
    display: flex;
    align-items: center;
    color:#fff;
  }
}
</style>
